export default {
  title: {
    list: "アカウント一覧",
    create: "アカウント作成",
    edit: "アカウント編集"
  },
  id: "ID",
  accountName: "アカウント名",
  email: "Eメール",
  officeableType: "会社区分",
  officeableName: "所属組織",
  managementOffice: "管理会社",
  subManagementOffice: "準管理会社",
  operationOffice: "運営会社",
  installationOffice: "設置会社",
  department: "組織",
  role: "役割",
  driverId: "ドライバーID",
  telephoneNumber: "電話番号",
  status: "ステータス",
  updatedAt: "最終更新日",
  updatedBy: "最終更新者",
  administrator: "管理者",
  driver: "ドライバー",
  accountCategory: "アカウント区分",
  confirmationModal: {
    valid: "有効",
    invalid: "無効",
    account: "アカウントを",
    statusConfirm: "にします。よろしいですか？"
  },
  csv: {
    importTitle: "アカウントの入力",
    currentLoginId: "現在ログイン中のoperation_office_idは { operationOfficeId } です。",
  },
  messages: {
    badRequestForDelete: '削除できませんでした。権限が付与されています。',
    getListError: "アカウント一覧の取得に失敗しました。",
    passwordGenerationError: "パスワードの自動生成にはドライバーIDの入力が必要です。",
    mailGenerationError: "メールアドレスの自動生成には所属組織の選択とドライバーIDの入力が必要です。",
    passwordMessage: "お手持ちのパスワードをご確認ください。"
  },
  form: {
    emailAddress: "メールアドレス",
    automaticIssuanceEmailAddress: "メールアドレスを自動発行する",
    NoEmailAddress: "メールアドレス無し",
    tempEmailAddress: "一時的なメールアドレス",
    password: "パスワード",
    driverMode: "ドライバーモード",
    operationVerificationAccount: "動作検証用アカウント",
    name: "名前",
    firstName: "名",
    lastName: "姓",
    nameKana: "名前(カナ)",
    firstNameKana: "名(カナ)",
    lastNameKana: "姓(カナ)",
    comment: "コメント",
    notificationSettings: {
      title: "通知設定",
      all: "全て",
      riskyDriving: {
        title: "危険挙動",
        rapid_acceleration: "急加速",
        rapid_deceleration: "急減速",
        steep_turn: "急旋回",
      },
      cvrUpload: {
        title: "ドラレコ映像取得",
        completed: "完了",
      },
      temperature: {
        title: "温度管理",
        sensor_disabled: "親機未接続",
        low_battery: "電池残量低下",
      },
      outputData: {
        title: "データ出力",
        completed: "完了",
      }
    },
    button: {
      passwordSetting: "パスワードを任意で設定する",
      passwordAutoGenerate: "パスワードを自動発行する",
      autoCreate: "自動作成",
    }
  },
  moveRoleAssignDisplayBtn: "権限付与をする",
  notAuthorizedMessage: "権限付与の権限がないので、管理者にご確認ください。",
  DriverModelInfoModal: {
    infoMessagesRow1: "ログインに必要な情報です。大切に保管してください",
    infoMessagesRow2: "スマホで給油/荷物量入力をする場合は必ず権限付与をしてください。",
  },
  InfoModal: {
    infoMessagesRow1: "アカウントに権限の付与をしてください。",
    infoMessagesRow2: "※権限付与をしないとログインができません。",
  }
}
